package br.com.texeratx.boardgametimeapp.ui.screens.login

import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.domain.usecases.login.LoginUseCase
import br.com.texeratx.boardgametimeapp.ui.screens.myclans.MyClansScreen
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import cafe.adriel.voyager.navigator.Navigator
import io.github.aakira.napier.Napier
import kotlinx.coroutines.launch

class LoginViewModel(
    private val loginUseCase: LoginUseCase,
    private val sessionManager: SessionManager
) : ScreenModel {

    var state = kotlinx.coroutines.flow.MutableStateFlow(LoginUiState())
        private set

    init {
        screenModelScope.launch {
            val savedEmail = sessionManager.load()?.email.orEmpty()
            if (savedEmail.isNotBlank()) {
                state.value = state.value.copy(email = savedEmail)
            }
        }
    }

    fun updateEmail(value: String) {
        state.value = state.value.copy(email = value)
    }

    fun updatePassword(value: String) {
        state.value = state.value.copy(password = value)
    }

    fun login(navigator: Navigator) {
        screenModelScope.launch {
            state.value = state.value.copy(isLoading = true, error = null)

            val result = loginUseCase(state.value.email, state.value.password)

            result.fold(
                onSuccess = {
                    Napier.d("LoginViewModel → login OK")

                    navigator.replaceAll(MyClansScreen())

                    state.value = state.value.copy(
                        isLoading = false,
                        isLogged = true
                    )
                },
                onFailure = {
                    Napier.e("LoginViewModel → erro no login", it)

                    state.value = state.value.copy(
                        isLoading = false,
                        error = it.message ?: "Erro inesperado"
                    )
                }
            )
        }
    }
}
